
<template lang="pug">
  Slide(:enable-scroll-indication="true")
    .content-container
      h1 How To Avoid Phishing Scams
  
      p.instructions Phishing is a dangerous social engineering attack and one of the most likely you’ll encounter.
      p.instructions Select each tip to find out what you can do to prevent a phishing attack.

      ModalStack
        .modal-container
          Modal(
            title="Stop, Look, and Think"
            :image="require('@/assets/images/700_StopLookThink.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckRed.png')"
            alt-completed="Completed"
            :completion-by-inner-component="false"
            size="custom"
            aria-describedby="modal1"
          )
            template(v-slot:modalContainer)
              .modal-box#modal1
                h2 Stop, Look, and Think
                p Remember, the attacker wants you to react without thinking first. You can identify most scams by simply slowing down and taking time to review all parts of an email carefully.

          Modal(
            title="Look for Warning Signs"
            :image="require('@/assets/images/700_WarningSigns.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckRed.png')"
            alt-completed="Completed"
            :completion-by-inner-component="false"
            size="custom"
            aria-describedby="modal2"
          )
            template(v-slot:modalContainer)
              .modal-box#modal2
                h2 Look for Warning Signs
                p Threatening or urgent language, generic greetings such as “Dear User,” unexpected attachments, random or suspicious links, and spelling errors are all common indicators of phishing scams.

          Modal(
            title="Beware of Attachments"
            :image="require('@/assets/images/700_Attached.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckRed.png')"
            alt-completed="Completed"
            :completion-by-inner-component="false"
            size="custom"
            aria-describedby="modal3"
          )
            template(v-slot:modalContainer)
              .modal-box#modal3
                h2 Beware of Attachments
                p Email attachments are common delivery methods for malware. Never open or download attachments you weren’t expecting, regardless of the file type or possible contents. 

          Modal(
            title="Use the Hover Technique"
            :image="require('@/assets/images/700_Hover.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckRed.png')"
            alt-completed="Completed"
            :completion-by-inner-component="false"
            size="custom"
            aria-describedby="modal4"
          )
            template(v-slot:modalContainer)
              .modal-box#modal4
                h2 Use the Hover Technique
                p When on a traditional computer, hover your mouse pointer over links to reveal the full web address. Carefully inspect it to ensure it’s directing you to a legitimate site that makes sense within the context of the message. If you’re unsure, don’t click!

          Modal(
            title="Make No Assumptions"
            :image="require('@/assets/images/700_Assumptions.png')"
            alt=""
            :image-completed="require('@/assets/images/000_CheckRed.png')"
            alt-completed="Completed"
            :completion-by-inner-component="false"
            size="custom"
            aria-describedby="modal5"
          )
            template(v-slot:modalContainer)
              .modal-box#modal5
                h2 Make No Assumptions
                p As a general rule, avoid assuming someone is who they claim to be. Treat all requests for sensitive information or money with a high degree of skepticism, no matter who or where those requests come from.
    
</template>


<script>
export default {
  methods: {
    attachModalCSS() {
        document.querySelector('body').classList.add('text-modals')
    },
    detachModalCSS() {
        document.querySelector('body').classList.remove('text-modals')
    }
  },
  mounted() {
    this.attachModalCSS()
  },
  destroyed() {
    this.detachModalCSS()
  }
}
</script>

<style lang='scss'>
@import "@/assets/css/_modals";
</style>

<style scoped lang="scss">
@import "@/assets/css/styles";

.slide-wrapper {
  padding: 40px !important;
  background-image: url('../assets/backgrounds/BG_Desktop_Orange.png')
}
.content-container {
  min-height: 100%;
  background-color: $light-orange;
  padding: 20px;
  box-shadow: 5px 5px 3px #00000033;
  h1 {
    @include fs-section-header;
    text-align: center;
  }
  .instructions {
    @include fs-instructions();
  }

}

.ModalStack {
  .modal-container {
    // height: 100%;
    max-width: 885px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 20px;
    justify-content: center;
    margin: 0 auto;
    .modal {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: white;
      min-width: 270px;
      height: 200px;
      padding: 5px;
      border-radius: 10px;
      box-shadow: 5px 5px 3px #00000033;
      ::v-deep .modal-controller {
        img {
          width: auto;
          height: 80%;
          max-height: 80px;
        }
        .h4 {
          color: black;
          margin-bottom: 20px;
        }
      }
    }
  }
}

</style>
